(function () {
  'use strict';

  const STORAGE_KEY = 'tinylittle_wishlist';

  function getWishlist() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      const parsed = saved ? JSON.parse(saved) : [];

      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      console.warn('Tinylittle wishlist could not be saved.');
    }
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function updateWishlistCount() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (element) {
      element.textContent = count;
      element.hidden = count === 0;
    });
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      const handle = button.dataset.wishlistHandle;
      const active = wishlist.includes(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      button.setAttribute(
        'aria-label',
        active
          ? 'Remove from wishlist'
          : 'Add to wishlist'
      );
    });
  }

  function toggleWishlist(handle) {
    if (!handle) return;

    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(function (item) {
        return item !== handle;
      });
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);

    updateWishlistButtons();
    updateWishlistCount();

    document.dispatchEvent(
      new CustomEvent('tinylittle:wishlist-updated', {
        detail: {
          wishlist: wishlist
        }
      })
    );
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-button]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.wishlistHandle;

    toggleWishlist(handle);
  });

  window.TinyLittleWishlist = {
    get: getWishlist,
    add: function (handle) {
      if (!handle) return;

      const wishlist = getWishlist();

      if (!wishlist.includes(handle)) {
        wishlist.push(handle);
        saveWishlist(wishlist);
      }

      updateWishlistButtons();
      updateWishlistCount();
    },
    remove: function (handle) {
      const wishlist = getWishlist().filter(function (item) {
        return item !== handle;
      });

      saveWishlist(wishlist);

      updateWishlistButtons();
      updateWishlistCount();
    },
    has: isInWishlist
  };

  function initWishlist() {
    updateWishlistButtons();
    updateWishlistCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }

  document.addEventListener('shopify:section:load', initWishlist);
})();